export default {
  title: 'World Manufacturer Identifier',
  close: 'Close',
  cookiePolicy: {
    headline: 'Use of cookies',
    text: 'We use cookies to provide our service. By continuing to browse the site, you agree to our use of cookies. Read more about our Privacy Policy by following this link:',
    datenschutz: {
      text: 'Privacy Policy',
      href: 'https://www.kba.de/DE/Service/Hinweise/Datenschutz/datenschutz_node.html'
    },
    button: 'OK'
  },
  kba: {
    breadcrumb: {
      start: 'Start'
    },
    logo: {
      title: 'web presence of Kraftfahrt Bundesamt',
      href: 'kba-info.do?target=home&language=en'
    },
    header: {
      contact: {
        label: 'Contact',
        href: 'https://www.kba.de/EN/Service/Kontakt/kontakt_node.html'
      },
      press: {
        label: 'Press',
        href: 'https://www.kba.de/EN/Presse/presse_node.html'
      },
      glossary: {
        label: 'Glossary',
        href: 'https://www.kba.de/EN/Service/Glossar1/glossar_node.html'
      },
      rss: {
        label: 'RSS',
        href: 'https://www.kba.de/EN/Service/RSSNewsfeed/rssnewsfeed_node.html'
      },
      logout: {
        label: 'Logout'
      },
      topics: 'Topics',
      statistic: 'Statistics',
      publications: 'Publications',
      kba: 'The KBA'
    },
    footer: {
      topics: {
        title: 'Topics',
        drivingSutability: 'Evaluation of driving suitability',
        centralRegister: 'Central registers',
        typeApproval: 'Type approval',
        marketSurveillance: 'Market surveillance'
      },
      statistics: {
        title: 'Statistics',
        products: 'Statistic Products',
        vehicles: 'Vehicles',
        drivers: 'Drivers',
        motorTransport: 'Motor transport',
        researchDataCenter: 'Research data center',
        projects: 'Projects',
        userInformation: 'User information',
        methods: 'Methodological Explanations',
        publicationsVehicleStatistics: 'Publications of vehicle statistics',
        directories: 'Directories',
        questionnaireRoadHaulageStatistics:
          'Questionnaire of road haulage statistics',
        faqStatistic: 'FAQ Statistic'
      },
      services: {
        title: 'Services',
        onlineSericeCitizen: 'Online service for citizens',
        onlineServiceRegisteredUsers: 'Online service for registered users',
        openData: 'Open Data',
        formulars: 'Formulars'
      },
      publications: {
        title: 'Publications'
      },
      kba: {
        title: 'The KBA',
        titleLong: 'The Kraftfahrt-Bundesamt',
        president: 'The President',
        organization: 'Organization',
        advisoryBoard: 'Advisory Board',
        working: 'Working at the KBA',
        apprenticeship: 'Apprenticeship at the KBA',
        internship: 'Internship at the KBA',
        history: 'History and brochures',
        contact: 'Contact',
        directions: 'Directions',
        businessHours: 'Business hours'
      },
      middleFooter: {
        description:
          'is a higher federal authority  within the scope of the ',
        centralAuthorityNumber: 'Central authority number',
        infoNumber: 'For questions about all authorities in Germany',
        hours: 'Mon–Fri from 8:00 – 18:00',
        bmv: {
          label: 'Federal Ministry of Transport.',
          href: 'https://www.bmv.de/EN/Home/home.html'
        }
      },
      lowerFooter: {
        accessibility: {
          label: 'Accessibility',
          href: 'kba-info.do?target=accessibility&language=en'
        },
        imprint: {
          label: 'Imprint',
          href: 'kba-info.do?target=imprint&language=en'
        },
        privacy: {
          label: 'Privacy',
          href: 'kba-info.do?target=privacy&language=en'
        },
        explanation: {
          label: 'Help',
          href: 'kba-info.do?target=explanation&language=en'
        },
        content: {
          label: 'Table of contents',
          href: 'kba-info.do?target=content&language=en'
        }
      }
    }
  },
  dataIterator: {
    noResultsText: 'No matching records found',
    loadingText: 'Loading items...'
  },
  dataTable: {
    itemsPerPageText: 'Rows per page:',
    ariaLabel: {
      sortDescending: ': Sorted descending. Activate to remove sorting.',
      sortAscending: ': Sorted ascending. Activate to sort descending.',
      sortNone: ': Not sorted. Activate to sort ascending.'
    },
    sortBy: 'Sort by'
  },
  dataFooter: {
    itemsPerPageText: 'Items per page:',
    itemsPerPageAll: 'All',
    nextPage: 'Next page',
    prevPage: 'Previous page',
    firstPage: 'First page',
    lastPage: 'Last page',
    pageText: '{0}-{1} of {2}'
  },
  datePicker: {
    itemsSelected: '{0} selected'
  }
}
